import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const loadReconciliationFileCreateAtom = createMutationAtomFactory(
  'trade.loadReconciliationFileCreate',
  (params: {
    fileName: string;
    mimeType: string;
    reconciliationId: string;
    fileSize: number;
    public?: boolean;
  }) => ({
    tradeLoadReconciliationFileCreate: {
      __args: {
        reconciliationId: params.reconciliationId,
        input: {
          fileName: params.fileName,
          fileSize: params.fileSize,
          mimeType: params.mimeType,
          public: params.public ?? false,
        },
      },
      file: {
        id: true,
        fileName: true,
        fileSize: true,
        mimeType: true,
        status: true,
      },
      uploadUrl: true,
    },
  }),
);
